<template>
    <div id="menu-nav" :class="{'menu-open':open}" @click="open=true">
        <div class="content">
            <div class="logo">
                <img src="/favicon.png" alt="">
                <div class="title">
                    Archistoire<br/>
                    <span>Lucas ISNARDON</span>
                </div>
                <div class="close" @click.stop.prevent="open=false">
                    <i class="fal fa-angle-left"></i>
                </div>
            </div>
    
            <ul class="tree">
                <tree-li-vertical v-for="(content,key) in nav.contents" :key="key" :content="content"/>
            </ul>
    
            <div v-html="css"></div>
        </div>
    </div>
</template>

<script>
import Btn from "@/modules/buttons/btn";
import TreeLiVertical from "@/modules/tree/tree-li-vertical";
import nav from "@/class/nav/nav";

export default {
    name: "Menu_Nav",
    components: {TreeLiVertical, Btn},
    data(){
        return{
            open:true,
            nav:nav,
        }
    },
    computed:{
        css(){
            if(nav.getCurrent() === null) return;
            return "<style>:root { --cActive : "+this.$store.getters.colorByType(this.nav.getCurrent().getObjectType())+"; --cActiveSub: "+this.$store.getters.colorByType(this.nav.getCurrent().getObjectType())+"}</style>"
        },
    }
}
</script>